import gdscript from "refractor/gdscript";
export default gdscript;